<template>
  <div style="padding-bottom: 60px;" v-if="draftinfo">
    <div class="down-tips-view packDown">
      <div class="down-tips">
        <el-link type="success"><span class="black-font">打包文件较多时，推荐使用“编号筛选”下载，方便核对！</span></el-link>
      </div>
      <div class="down-tips-message">
        <i class="el-icon-message-solid"></i>
      </div>
    </div>
    <div class="packDown-content">
      <div class="packDown-view" style="font-size: 20px;">
        <div style="padding: 20px 60px; cursor: pointer;">
          <div class="flex align-center" style="width: 100%;">
            <div class="text-xl" style="min-width: 100px;">已选文件：</div>
            <el-card class="down-box-card text-lg padding-sm" style="width: 100%;">
              <div class="flex align-center">
                <div>已选文件大小：</div>共计 {{total}}个，{{MG(totalSize)}}
              </div>
              <div class="flex align-center margin-top-lg">
                <div>剩余下载额度：</div>剩余 {{MG(residueSize)}}
              </div>
            </el-card>
          </div>
          <div style="padding-top: 40px;font-weight: 500;" class="font-size18 flex align-center">
            <div class="text-xl" style="min-width: 100px;">分包大小：</div>
            <div style="width: 100%;">
              <el-slider
                      v-model="singlePackageFileSize"
                      :step="1"
                      :min="3"
                      :max="30"
                      :marks="marks"
                      :format-tooltip="formatTooltip"
                      show-stops>
              </el-slider>
            </div>
          </div>
          <div style="padding: 40px 0;font-weight: 500;" class="font-size18 flex align-center">
            <div class="text-xl" style="min-width: 100px;">文件夹：</div>
            <div style="width: 100%;padding-left: 50px;">
              <el-radio-group v-model="isFolder">
                <el-radio :label="1" style="transform:scale(1.5);">以“每次投稿”为单独文件夹</el-radio>
                <el-radio :label="0" style="transform:scale(1.5);margin-left: 120px;">所有投稿放在一个文件夹</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div style="font-weight: 500;padding-bottom: 20px;" class="font-size18">
            指定文件命名 (点击下方选择)
          </div>
          <div>
            <el-tag v-for="(item,tagidx) in tags" v-bind:key="'tags'+tagidx"
                    :type="item.checked?'success':'info'"
                    @click="checkItem(item,tagidx)"
                    style="margin-right: 10px; margin-top: 10px;">{{item.name}}
            </el-tag>
          </div>
          <div v-if="rename.length>0" class="green-font" >
            <template v-for="(item,index) in rename">
              <el-tag size="mini" closable type="success"
                      style="margin-top: 15px;" @close="removeRename(index)"
              >{{item.name}}
              </el-tag>
              {{index + 1 == rename.length ? '' : '-'}}
            </template>

          </div>
          <div v-if="renameLength>255"
               class="red-font margin-top-sm text-df">当前命名超长，可能导致下载后无法解压，建议减少命名字段（电脑系统限制文件名不超过255个字符）</div>
          <el-divider></el-divider>
          <div style="padding: 10px 0;font-weight: 500;" class="font-size18 flex align-center">
            <div class="text-xl" style="min-width: 100px;">导出数据：</div>
            <div style="width: 100%;padding-left: 50px;">
              <el-checkbox-group v-model="isExcel">
                <el-checkbox :label="1" style="transform:scale(1.5);">同时导出Excel表格</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="text-lg text-gray padding-top-xl">
            <div class="margin-bottom-sm">说明：</div>
            <div class="margin-bottom-sm">1、默认单次打包不超过10G；超过会自动分包</div>
            <div class="margin-bottom-sm">2、文件命名格式，免费版命名最多选择3个格式组合，
              <a :href="buyVipUrl" target="_blank" ref="buyVipUrl">升级版本；</a></div>
            <div class="margin-bottom-sm">3、如需下载作品进行评选，可参考文档 <a href="https://mp.weixin.qq.com/s/oQT-NZAtSV5j2DM_3_2aUA" target="_blank">在线评选；</a></div>
            <div class="margin-bottom-sm">4、打包下载常见问题：
              <a style="color: #E0605A;" href="https://support.qq.com/products/57964/faqs/108280" target="_blank">点我查看更多注意事项</a></div>
          </div>
          <div class="flex align-center justify-end text-xl padding-top-xl">
            <button class="cu-btn bg-green padding-tb-xl radius padding-lr-xxxl text-xxl text-500" @click="downDialog">开始打包</button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
            title="" class="fotoo"
            :visible.sync="dialogVisible"
            width="900" append-to-body
            :before-close="handleClose">
      <div class="flex flex-direction align-center justify-content padding-lr-xl padding-bottom-lg">
        <div class="flex flex-direction justify-start text-black font-size24" style="width: 80%;">
          <div class="text-bold">
            打包任务创建成功
          </div>
          <div class="margin-top">
            {{timeNum}}秒后将自动跳转至下载记录
          </div>
          <div class="margin-top">
            请稍后至 <span class="text-green" @click="handleClose">下载记录</span> 中查询处理进度
          </div>
          <div class="margin-top">
            预计处理时间：10分钟（仅供参考，以实际处理时间为准）
          </div>
          <div>
            打包文件保留时间：24小时，到期会自动清理，建议及时下载
          </div>
        </div>
        <div style="margin-top: 180px;" @click="handleClose"
             class="bg-green radius padding-tb-sm padding-lr-lg font-size18 cursor">前往下载记录</div>
      </div>
    </el-dialog>
    <downTipDialog ref="downTipDialog"></downTipDialog>
  </div>
</template>

<script>
  import App from '../util/comfun'
  import ElCheckbox from "../../node_modules/element-ui/packages/checkbox/src/checkbox.vue";
  import downTipDialog from "./components/downTipDialog.vue"
  import JSZip from 'JSZip'
  const M = 1024 * 1024
  const G = M * 1024
  const oneMaxSize = 3 //G
  const limitRows=1000
  export default {
    data () {
      return {
        oneMaxSize:oneMaxSize,
        M: M,
        totalSize: 0,
        residueSize:0,
        isFolder: 0,
        //自定义收集项    customInfo
        tags: [
          {key: 'serialNumber', name: '投稿编号',},
          {key: 'submissionCreateTime', name: '投稿时间',},
        ],
        rename: [],
        draftinfo:null,
        dialogVisible:false,
        timeNum:0,
        total:0,
        singlePackageFileSize:10,
        marks: {
          3: '3G',
          10: {
            style: {
              color: '#23b092'
            },
            label: this.$createElement('strong', '10G')
          },
          30: '30G',
        },
        buyVipUrl:'',
        isExcel:[1],
        renameLength:0,
      }
    },
    components:{
      ElCheckbox,
      downTipDialog,
    },
    methods:{
      MG: App.MG,
      getDetail(){
        this.activityId=this.$route.query.activityId
        this.activityName=this.$route.query.activityName
        App.Contribution.GetContributionById({id:App.packDown.activityId}).then(res=>{
          this.draftinfo=res.data
          this.buyVipUrl=App.getH5({
            version:encodeURIComponent(JSON.stringify({
              from:'pc',
              token:wxlite.getStorageSync('token'),
              uid:this.draftinfo.createBy})),
            "_":'',
          },'')
          this.setTags()
        })
      },
      removeRename(index) {
        let tag=this.rename.splice(index, 1)
        this.tags.some((tt,idx)=>{
          if(tt.key==tag[0].key){
            tt.checked=false
            return true
          }
        })
        this.checkRenameLength()
      },
      checkItem(item,tagidx) {
        let flag = true
        this.rename.some(it => {
          if (it.key == item.key) {
            flag = false;
            return true
          }
        })
        if (flag) {
          if(this.draftinfo.vipType<1){
            if(this.rename.length>=3){
              return this.showConfirm()
            }
          }
          this.rename.push(item)
          this.tags[tagidx].checked=flag
        }
        this.checkRenameLength()
      },
      checkRenameLength(){
        let length=0
        this.rename.forEach(it=>{
          length+=it.maxLength
        })
        //console.log('this.rename',length,this.rename)
        this.renameLength=length
      },
      showConfirm(){
        let html = `
<div class="flex-lm" style="align-content: flex-start">
    <div style="font-size:34px;color:#FFA200; margin-left:10px;margin-right: 20px;"><i class="el-icon-warning"></i></div>
    <div style="padding-top: 20px;">
<div style="font-size: 16px;color: #5d5d5d;">免费版最多选择3个，作为文件名称，升级版本后不限制</div>
    </div>
</div>
`
        this.$confirm(html, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '知道了',
          confirmButtonClass: 'button-bg-green',
          cancelButtonText: '升级版本',
          cancelButtonClass: 'button-line-green',
        }).catch(() => {
          //this.$router.push({path: '/checkout/buyVip?activityId='+this.draftinfo.activityId+'&activityName='+this.draftinfo.activityName})
          this.$refs.buyVipUrl.click()
        });
      },
      setTags() {
        this.tags = [
          {key: 'serialNumber', name: '投稿编号',maxLength:5},
          {key: 'submissionCreateTime', name: '投稿时间',maxLength:20},
          //{key:'wardingName', name:'相册名称',},
          {key: 'originFileName', name: '原始文件名',maxLength:50},
        ]
        if (this.draftinfo.activityAuth.isTrack == 1) {
          this.tags.push({key: 'trackName', name: this.draftinfo.activityAuth.trackName||'分组或赛道',maxLength:50})
        }
        if (this.draftinfo.activityAuth.isTag == 1) {
          this.tags.push({key: 'tagName', name: this.draftinfo.activityAuth.tagName||'征稿单元',maxLength:50})
        }
        if (this.draftinfo.activityAuth.isContact == 1) {
          if (this.draftinfo.activityAuth.isMobile == 1) {
            this.tags.push({key: 'contactInfo', name: '手机号',maxLength:15})
          }
        }
        if (this.draftinfo.activityAuth.isSubmissionTips == 1) {
          if (this.draftinfo.activityAuth.isAuthorName == 1) {
            this.tags.push({key: 'autograph', name: '作者署名',maxLength:20})
          }
          if (this.draftinfo.activityAuth.isSubmissionName == 1) {
            this.tags.push({key: 'submissionName', name: '作品名称',maxLength:30})
          }
        }
        if (this.draftinfo.customFormInfo.isEnable == 1) {
          this.draftinfo.customFormInfo.inputList.forEach(item => {
            //console.log('maxLength',item)
            let maxLen=item.maxLen
            if(maxLen==0){
              if(item.inputType==3){
                maxLen=50
              }else{
                const rulus=[
                  {name:'不限',rule:'',dfMaxLen:10000,reg:null,hasUseDf:'将df值映射到max、min'},
                  {name:'电子邮箱',rule:'email',reg:/^[^@]+@.*[^\.]+\.[a-z]{2,5}$/i,dfMaxLen:50},
                  {name:'手机号码',rule:'phone',reg:null,dfMaxLen:15},
                  {name:'网址',rule:'link',reg:/^http(s)?:\/\/[^\.]+\..{3,}/,dfMaxLen:50},
                  {name:'地址',rule:'address',reg:null,dfMaxLen:100},
                  {name:'数字',rule:'number',reg:/^[\d]+(\.\d)?[\d]*$/,dfMaxLen:20},
                  {name:'英文',rule:'english',reg:/^[\x20-\x7e]*$/,dfMaxLen:500},
                  {name:'身份证号码',rule:'code',reg:/(^\d{15}$)|(^\d{17}([0-9]|X|x)$)/,dfMaxLen:18},
                  {name:'日期（2022-02-22）',rule:'date',reg:null,dfMaxLen:10},
                  {name:'多行文本',rule:'textarea',dfMaxLen:10000,reg:null},
                  {name:'省/市/区',rule:'region',dfMaxLen :100,reg:null,hasUseDf:true,region:['','province','city','sub-district','region']},
                ];
                maxLen=rulus[item.inputRule].dfMaxLen
              }

            }
            if(item.inputRule==10 && maxLen>10000){maxLen=50}
            if(maxLen==0) maxLen=10000
            this.tags.push({key: item.id, name: item.name, type: 'customInfo',maxLength:maxLen})
          })
        }
      },
      downDialog(){
        if(this.userDownloading) return this.$message({
          showClose: true,
          message: '正在提交，稍等片刻'
        });
        //this.dialogVisible=false
        //this.$emit('down',{type:type})
        if (this.residueSize < 1) {
          return this.$message({
            showClose: true,
            message: '剩余下载额度已欠费，请充值'
          });
        }
        if (this.rename.length < 1) {
          return this.$message({
            showClose: true,
            message: '必须指定文件命名'
          });
        }
        this.$confirm('打包开始后无法取消，并会扣除下载额度', {
          confirmButtonText: '确定打包',
          cancelButtonText: '取消',
          showClose:false,
          type: 'warning'
        }).then(res=>{
          this.down()
        })
      },
      async down(){
        await this.downexcelAll()
        let params = JSON.parse(JSON.stringify(this.params))
        params.isFolder = this.isFolder ? 1 : 0
        params.inputIdList = []
        params.fileNameList = []
        this.rename.forEach(item => {
          if (item.type == 'customInfo') {
            params.inputIdList.push(item.key)
            params.formId = this.draftinfo.customFormInfo.id
          } else {
            params.fileNameList.push(item.key)
          }
        })
        if (params.inputIdList.length > 0) {
          params.fileNameList.push('customInfo')
        }
        params.wardingResultId=params.wardingId||''
        if (params.materialType) {
          params.activityMaterialType = params.materialType
          delete params.materialType
        }
        this.userDownloading=true
        params.singlePackageFileSize=this.singlePackageFileSize*1024*1024*1024
        App.demand('/download/userDownload', 'POST', params).then(res => {
          setTimeout(()=>{this.userDownloading=false},0)
          if (res.code != 200) {
            return this.$message({
              showClose: true,
              message: res.message,
            });
          }
          //this.diaplayQrcode()
          this.initTimeGo()
          this.dialogVisible=true

        })
      },
      initTimeGo(){
        this.timeNum=10
        if(this.timeNumInterval){
          clearInterval(this.timeNumInterval)
          this.timeNumInterval=null
        }
        this.timeNumInterval=setInterval(()=>{
          this.timeNum-=1
          if(this.timeNum<1){
            return this.handleClose()
          }
        },1000)
      },
      handleClose(down){
        if(this.timeNumInterval){
          clearInterval(this.timeNumInterval)
          this.timeNumInterval=null
        }
        this.$router.replace({ path: '/home/downhis'})
        if(down) down()
      },
      formatTooltip(val){
        return val+'G'
      },
      async downexcelAll(){//下载全部
        if(!this.isExcel || this.isExcel.length<1) return;
        if(this.total<limitRows) return this.downexcel(true)
        let pageCount=Math.ceil(this.total/limitRows)
        this.downOverNum=1
        let loading=this.$loading({
          lock: true,
          text: "正在下载 "+this.downOverNum+'/'+pageCount,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
          customClass:'custom-loading'
        });
        let params=JSON.parse(JSON.stringify(this.params))
        let fn=this.draftinfo.activityName.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g,'')
        var zip = new JSZip();
        var zippack=zip.folder((fn||this.draftinfo.activityId)+'.xlsx');
        for(;this.downOverNum<=pageCount;){
          params.pageIndex=this.downOverNum
          params.pageSize=limitRows
          let resData=await App.Submission.Export(params)
          let filename=`part.${this.downOverNum}.xlsx`
          zippack.file(filename,resData)
          document.querySelector(".el-loading-text").innerHTML = "正在下载 "+(this.downOverNum++)+'/'+pageCount
        }
        document.querySelector(".el-loading-text").innerHTML = "下载完成，正在打包..."
        zip.generateAsync({type:"blob"}).then((content)=>{
          let aurl = window.URL.createObjectURL(content)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = aurl
          link.setAttribute('download', (fn||this.draftinfo.activityId)+".xlsx.zip")
          document.querySelector(".el-loading-text").innerHTML = "打包完成!"
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          setTimeout(()=>{loading.close();},800)
        })
      },
      async downexcel(hasAll=false){
        if(!hasAll && this.workidarr.length<1){
          this.$message({
            showClose: true,
            message: '请选择投稿'
          });
          return
        }
        const loading = this.$loading({
          lock: true,
          text: '数据准备中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let params=JSON.parse(JSON.stringify(this.params))
        params.pageIndex=1
        params.pageSize=limitRows
        if(!hasAll){
          if(this.workidarr.length>0){
            params.submissionIdList=this.workidarr
          }
        }
        App.Submission.Export(params).then(data=>{
          loading.close();
          //let blob = new Blob([data], {type: "application/vnd.ms-excel"});
          let blob = new Blob([data], {type: "application/vnd.ms-excel"})
          //let blob = new Blob([data]);
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          let fn=this.draftinfo.activityName.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g,'')
          link.setAttribute('download', (fn||this.draftinfo.activityId)+'.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        // this.exportData();
      },
    },
    mounted(){
      if(!App.packDown){
        App.packDown=App.cache('packDown')
      }
      console.log('App.packDown',App.packDown)
      this.totalSize=App.packDown.totalSize
      this.residueSize=App.packDown.residueSize
      this.params=App.packDown.res.params
      this.total=App.packDown.res.total
      this.getDetail()
    },

  }
</script>

<style scoped>
  .down-tips-view{
    position: relative;
    font-size: 14px;
    border-radius: 10px 10px 0 10px;
    overflow: hidden;
    width: 537px;
    height: 40px;
    margin-left: 80px;
  }
  .down-tips{
    width: 537px;
    height: 40px;
    background: #facebe;
    border-radius: 0 28px 0px 10px;
    position: absolute;
    left:0px;
    top:0px;
    content: "";
    color: #FE7157;
    font-size: 14px;
    line-height: 40px;
    text-indent: 25px;
  }
  .down-tips::after{
    width: 42px;
    height: 38px;
    position: absolute;
    left:0;
    top:0px;
    content: "";
    color: #fefefe;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    box-sizing: border-box;
    border-top: 40px solid #FE6E5B;
    border-right: 10px solid transparent;
  }
  .down-tips-message{
    width: 42px;
    height: 38px;
    position: absolute;
    left:8px;
    top:0px;
    content: "";
    color: #fefefe;
    font-size: 20px;
    line-height: 40px;
  }
  .packDown-content{
    width: calc(100% - 40px);
    position: relative;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #fefefe;
    border: 1px solid #979797;
    border-radius: 2px;
  }
  .packDown-view{
    max-width: 1160px;
    margin: 0 auto;
    padding: 20px 0 60px;
  }
  .packDown.down-tips-view{
    position: absolute;
    top:12px;
    left:200px;
    z-index: 99;
  }
</style>


// WEBPACK FOOTER //
// src/pages/packDown.vue